import * as jwt from 'jsonwebtoken';
import { logger } from 'logs';
import getConfig from 'next/config';

import type { JwtPayload } from './types';

const { serverRuntimeConfig } = getConfig();
let key = '';

if (serverRuntimeConfig.publicKey) {
  key = atob(serverRuntimeConfig.publicKey);
}

logger.info({
  key: '[JWT-PARSER][TOKEN][INIT]',
  params: {
    publicKey: key,
  },
});

export const jwtParser = async (token: string): Promise<JwtPayload> => {
  const payload = await jwt.verify(token, key, {
    algorithms: ['ES256'],
  });

  return payload as JwtPayload;
};
